export const MOBILE_NAVBAR_HEIGHT = '58';
